import type { ReactNode } from 'react';

export const symbol_web_asset_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24.75 0-42.37-17.63Q80-195.25 80-220v-520q0-24.75 17.63-42.38Q115.25-800 140-800h20v86L47-827q-9-9.07-9-21.53Q38-861 47.05-870q9.06-9 21.5-9Q81-879 90-870l765 765q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q821-54 812-63l-98-97H140Zm0-60h514L218-656h-78v436Zm740-520v512q0 15-9.32 22.5t-20.5 7.5q-11.18 0-20.68-7.68-9.5-7.69-9.5-22.32v-428H415q-12.44 0-23.72-5T372-674l-75-75q-6.92-7.81-8.46-16.41Q287-774 290-782t10.5-13q7.5-5 17.5-5h502q24.75 0 42.38 17.62Q880-764.75 880-740Z"
		/>
	</svg>
);
